import { Grid, InputLabel } from '@material-ui/core';
import ReCAPTCHA from 'react-google-recaptcha';
import styled from 'styled-components';

export const BottomPaddedGridItemS = styled(Grid)`
    padding-bottom: 20px;
`;

export const BottomPaddedGridItemM = styled(Grid)`
    padding-bottom: 50px;
`;

export const StyledReCAPTCHA = styled(ReCAPTCHA)`
    padding-bottom: 20px;
`;

export const StyledBlackInputLabel = styled(InputLabel)`
    color: black;

    &.Mui-required::after {
        position: relative;
        left: 2px;
    }
`;

export const StyledBlackLabel = styled.label`
    color: black;
`;
